import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map, timeout } from 'rxjs/operators';
import { UserService } from './../services/user.service';
import { HelperService } from '../services/helpers.service';
import { Router } from '@angular/router';


@Injectable()
export class ErpInterceptor implements HttpInterceptor {

  public static useErpHeader = true;

  constructor(
    private userS: UserService,
    public toast: ToastController,
    private helper: HelperService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = Date.now();

    // Headers
    const userJwt = this.userS.jwt || '';
    const baseConn = JSON.stringify({base: this.userS.base, emp_id: 1});

    let authReq = req.clone();
    if (!ErpInterceptor.useErpHeader) {
      return next.handle(authReq).pipe(finalize(() => ErpInterceptor.useErpHeader = true));
    }
    authReq = req.clone({
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: userJwt || '',
        BaseConn: baseConn,
      })
    });

    // https://blog.angularindepth.com/top-10-ways-to-use-interceptors-in-angular-db450f8a62d6
    return next.handle(authReq)
    .pipe(
      timeout(20000),
      map((event: HttpEvent<any>) => {
        // Ignora outros eventos - OPTIONS por exemplo
        if (!(event instanceof HttpResponse)) { return event; }

        // HTTP Status
        if (event.status === 200) {
          // Processa status do JSON
          if (event.body.status === false) {

            throw new Error(event.body.data?.error || event.body.data);

          }
          // Se tem data padrão, retorna
          if (event.body.data) {
            return event.clone({body: event.body.data});
          }
        }
      }, (error: Error) => {
         // Operation failed; error is an HttpErrorResponse
        console.error('HTTP failed', error);
      }),
      catchError((error: any) => {
        console.group(error);
        // 401 handled in auth.interceptor
        if (error.status === 401) {}
        if (error.name === 'TimeoutError'){
         // console.error('error timeout!!');
          this.helper.dismissLoader();
          this.toastError('Falha de conexão. Favor conectar com a internet').then();
          return throwError(error);
        }

        if (error.status === 0) {
        //  console.log(error);
        if (error.message !== 'Http failure response for https://*.api.alleshub.com.br/api_allescorp/checkin/post: 0 Unknown Error' &&
        error.message !== 'Http failure response for https://*.api.alleshub.com.br/api_allescorp/userApp/create: 0 Unknown Error' &&
          error.message !== 'Http failure response for https://*.api.alleshub.com.br/api_allescorp/pedido/updateEsalcorp: 0 Unknown Error' &&
          error.message !== 'Http failure response for https://*.api.alleshub.com.br/api_allescorp/file/post: 0 Unknown Error'){
            this.helper.toast('Falha ao conectar com o servidor, verifique sua conexão.' , 'danger');
          }
        if (error.message === 'Http failure response for https://*.api.alleshub.com.br/api_allescorp/userApp/create: 0 Unknown Error'){
              this.helper.dismissLoader();
              this.helper.showLoader('Falha ao conectar com o servidor, tentando novamente...');

            }
        return throwError(error);
        }
        if (error.status === 429) {
          this.helper.toast('Muitas tentativas de login, Favor aguarde um momento...', 'danger');
          return throwError(error);
        }

        // Toast
        const msg = (typeof error.error === 'string') ? error.error : error.message;
        this.toastError(msg).then();
        return throwError(error);
      }),
      finalize(() => {
        const elapsed = Date.now() - started;
        const msg = `${req.method} "${req.urlWithParams}" ${elapsed} ms.`;
        console.warn(msg);
      })
    );
  }

  async toastError(error) {
    const toast = await this.toast.create({
      color: 'danger',
      message: error,
      duration: 5000,
      buttons: [{
        text: 'OK',
        role: 'cancel'
      }]
    });
    toast.present();
  }

}

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ErpInterceptor, multi: true },
];
